module.exports = __webpack_public_path__ + "img/icon_heart_full_red.dad1d9f8.svg";